import * as Yup from "yup";

const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
export const alphaNumericPattern = /^[a-zA-Z0-9_]*$/;
export const onlyCharactersPattern = /^[a-zA-Z]*$/;
export const onlyNumbers = /^[0-9]*$/;
export const onlyCharactersWithSpacePattern = /^[a-zA-Z ]*$/;
const mobileNumberPattern = /^(\+\d{1,3}[- ]?)?\d{10}$/;
const passwordPattern = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
export const alphaNumericPatternWithDot = /^[a-zA-Z0-9_. ]*$/;
export const alphaNumericPatternWitSomeCharacters = /^[a-zA-Z0-9-_. ]*$/;
export const notAllowedSpecialCharacters = /^[^<>{}~]*$/;
export const alphaNumericPatternForPO = /^[a-zA-Z0-9_]*$/;

const validateNumberPlate = (plateNumber) => {
  const stateInitials = [
    // Add valid state initials here
    "AP",
    "AR",
    "AS",
    "BR",
    "CG",
    "GA",
    "GJ",
    "HR",
    "HP",
    "JH",
    "KA",
    "KL",
    "MP",
    "MH",
    "MN",
    "ML",
    "MZ",
    "NL",
    "OD",
    "PB",
    "RJ",
    "SK",
    "TN",
    "TS",
    "TR",
    "UK",
    "UP",
    "WB",
  ];

  // Regular expression patterns for different types of number plates
  const patterns = [
    // State codes followed by 1 to 2 digits and 1 to 2 letters
    new RegExp(`^(${stateInitials.join("|")})\\d{1,2}[A-Z]{1,2}\\d{1,4}$`, "i"),
    // Bharat series plates - XY Bh $$$$ XX
    /^\d{2}BH\d{4}[A-Z]{2}$/, // Updated pattern for Bharat series
  ];

  // Check if plateNumber matches any pattern
  return patterns.some((pattern) => pattern.test(plateNumber));
};

export const VENDOR_PROFILE = Yup.object().shape({
  email: Yup.string()
    .required("This field is required")

    .matches(emailPattern, "Email is not valid")
    .min(4, "Minimum 4 digit required")
    .max(50, "Max 50. digit required"),
  mobile: Yup.string()
    .required("This field is required")
    .matches(mobileNumberPattern, "Mobile number is not valid"),

  firstName: Yup.string()
    .required("This field is required")
    .trim()
    .min(3, "Minimum 3 digit required")
    .max(50, "Max 50. digit required")
    .matches(onlyCharactersPattern, "Only characters allowed"),
  lastName: Yup.string()
    .required("This field is required")
    .trim()
    .min(3, "Minimum 3 digit required")
    .max(50, "Max 50. digit required")
    .matches(onlyCharactersPattern, "Only characters allowed"),
});

export const VENDOR_REGISTRATION_STEP_1 = Yup.object().shape({
  vendorCode: Yup.string()
    .required("This field is required")
    .min(4, "Minimum 4 digit required")
    .max(16, "Max 16. digit required")
    .matches(alphaNumericPattern, "Only alphanumeric characters allowed"),

  gstin: Yup.string()
    .required("This field is required")
    .trim()
    .min(15, "Minimum 15 digit required")
    .max(16, "Maximum 16 digit required")
    .matches(alphaNumericPattern, "Only alphanumeric characters allowed"),
});
export const CHAT_THREAD = Yup.object().shape({
  userMessage: Yup.string()
    .required("This field is required")
    .min(3, "Minimum 3 characters required")
    .max(100, "Maximum 100 characters allowed")
    .matches(notAllowedSpecialCharacters, "Special characters not allowed"),
});

export const VENDOR_APPOINTMENT_STEP_1 = Yup.object().shape({
  poCount: Yup.number().required("This field is required"),
  poDetails: Yup.array().of(
    Yup.object().shape({
      poNumber: Yup.string()
        .required("This field is required")
        .min(9, "Minimum 9 digit required")
        .max(10, "Max 10. digit required")
        .matches(alphaNumericPattern, "Only alphanumeric characters allowed"),
      noOfCases: Yup.string()
        .required("This field is required")
        .matches(/^[0-9]+$/, "Must be only digits")
        .min(1, "Minimum 1 digit required"),
      countOfSkus: Yup.string()
        .required("This field is required")
        .matches(/^[0-9]+$/, "Must be only digits")
        .min(1, "Minimum 1 digit required"),
      materialTypeId: Yup.string().required(
        "Select one option , This field is required"
      ),
    })
  ),
});

export const VENDOR_APPOINTMENT_PRE_VERIFY_STEP_1 = Yup.object().shape({
  poCount: Yup.number().required("This field is required"),
  poDetails: Yup.array().of(
    Yup.object().shape({
      inputTypeId: Yup.string().required(
        "Select one option , This field is required"
      ),
      poNumber: Yup.string()
        .required("This field is required")
        .min(9, "Minimum 9 digits required")
        .max(10, "Maximum 10 digits required")
        .matches(alphaNumericPattern, "Only alphanumeric characters allowed"),
    })
  ),
});

export const VENDOR_APPOINTMENT_STEP_2 = Yup.object().shape({
  startTime: Yup.string().required("This field is required"),
});
export const VENDOR_APPOINTMENT_STEP_3 = Yup.object().shape({
  countOfvehicle: Yup.string().required("This field is required"),
  vehicleDetails: Yup.array().of(
    Yup.object().shape(
      {
        vrn: Yup.string().when("vrn", {
          is: (value) => value && value.trim().length > 0, // Test if value is present
          then: Yup.string().test(
            "number-plate",
            "Invalid vehicle registration number",
            validateNumberPlate
          ),
          otherwise: Yup.string().notRequired(), // If value is not present, validation is skipped
        }),
        otherwise: Yup.string().notRequired(),
        driverName: Yup.string()
          .nullable()
          .notRequired()
          .when("driverName", {
            is: (value) => value?.length,
            then: (rule) =>
              rule.matches(
                onlyCharactersWithSpacePattern,
                "Only characters allowed"
              ),
          }),
        driverContactNumber: Yup.string()
          .nullable()
          .notRequired()
          .when("driverContactNumber", {
            is: (value) => value?.length,
            then: (rule) =>
              rule
                .min(10, "Minimum 10 digit required")
                .max(10, "Maxmimum 10 digit required")
                .matches(/^[6-9]\d{9}$/, "Phone number is not valid"),
          }),
      },
      [
        ["driverContactNumber", "driverContactNumber"],
        ["vrn", "vrn"],
        ["driverName", "driverName"],
      ]
    )
  ),
  GSTIN: Yup.string()
    .required("This field is required")
    .trim()
    .min(15, "Minimum 15 digit required")
    .max(16, "Maximum 16 digit required")
    .matches(alphaNumericPattern, "Only alphanumeric characters allowed"),
});

export const VENDOR_APPOINTMENT = Yup.object().shape({
  poCount: Yup.number().required("This field is required"),

  poDetails: Yup.array()
    .of(
      Yup.object().shape({
        inputTypeId: Yup.string().required(
          "Select one option , This field is required"
        ),
        poNumber: Yup.string()
          .required("This field is required")
          .min(9, "Minimum 9 digits required")
          .max(10, "Maximum 10 digits required")
          .matches(
            alphaNumericPatternForPO,
            "Only alphanumeric characters allowed"
          ),
      })
    )
    .test("unique-po", null, function (poDetails) {
      if (!poDetails) return true;

      const seen = new Map();
      const errors = [];

      poDetails.forEach((item, index) => {
        if (!item.poNumber) return;
        const trimmedPoNumber = item.poNumber.replace(/^0+/, "").trim(); // Trim leading zeros
        if (seen.has(trimmedPoNumber)) {
          errors[index] = this.createError({
            path: `poDetails.${index}.poNumber`,
            message: "Duplicate PO/ASN is not allowed",
          });
        } else {
          seen.set(trimmedPoNumber, index);
        }
      });

      return errors.length ? new Yup.ValidationError(errors) : true;
    }),
});

export const VENDOR_REGISTRATION_STEP_2 = Yup.object().shape({
  vendorSPOCemail: Yup.string()
    .required("This field is required")

    .matches(emailPattern, "Email is not valid")
    .min(4, "Minimum 4 digit required")
    .max(50, "Max 50. digit required"),
  vendorSPOCMobile: Yup.string()
    .required("This field is required")
    .matches(mobileNumberPattern, "Mobile number is not valid"),

  SPOCFirstName: Yup.string()
    .required("This field is required")
    .trim()
    .min(3, "Minimum 3 digit required")
    .max(50, "Max 50. digit required")
    .matches(onlyCharactersPattern, "Only characters allowed"),
  SPOCLastName: Yup.string()
    .required("This field is required")
    .trim()
    .min(3, "Minimum 3 digit required")
    .max(50, "Max 50. digit required")
    .matches(onlyCharactersPattern, "Only characters allowed"),
});
export const VENDOR_REGISTRATION_STEP_4 = Yup.object().shape({
  password: Yup.string()
    .required("This field is required")

    .matches(
      passwordPattern,
      "Min 8 letter password, with at least a symbol, upper and lower case letters and a number"
    )
    .min(
      8,
      "Min 8 letter password, with at least a symbol, upper and lower case letters and a number"
    ),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("password"), null], "Password not match")
    .required("This field is required"),
});

export const ADD_NEW_QUERY = Yup.object().shape({
  queryType: Yup.string().required("Please select the query"),
  querySubType: Yup.string().required("Please select the sub query"),
  comment: Yup.string()
    .required("Please provide some comment")
    .trim()
    .min(3, "Enter minumum 3 words")
    .max(100, "Maximum 100 characters allowed")
    .matches(notAllowedSpecialCharacters, "Special characters not allowed"),
});

export const COMMENT_VALIDATION = Yup.object().shape({
  comment: Yup.string()
    .required("Please provide some comment")
    .trim()

    .max(250, "Maximum 250 characters allowed")
    .matches(notAllowedSpecialCharacters, "Special characters not allowed"),
});

export const REMARK_VALIDATION = Yup.object().shape({
  remark: Yup.string()
    .required("Please provide some comment")
    .trim()

    .max(250, "Maximum 250 characters allowed")
    .matches(notAllowedSpecialCharacters, "Special characters not allowed"),
});
export const RESET_PASSWORD = Yup.object().shape({
  password: Yup.string()
    .required("This field is required")
    .matches(
      passwordPattern,
      "Min 8 letter password, with at least a symbol, upper and lower case letters and a number"
    )
    .min(
      8,
      "Min 8 letter password, with at least a symbol, upper and lower case letters and a number"
    ),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("password"), null], "Password not match")
    .required("This field is required"),
});
export const VERIFY_TOKEN_PASSWORD = Yup.object().shape({
  token: Yup.string().required("This field is required"),
  password: Yup.string()
    .required("This field is required")

    .matches(
      passwordPattern,
      "Min 8 letter password, with at least a symbol, upper and lower case letters and a number"
    )
    .min(
      8,
      "Min 8 letter password, with at least a symbol, upper and lower case letters and a number"
    ),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("password"), null], "Password not match")
    .required("This field is required"),
});

export const bulkAppointmentValidation = Yup.object().shape({
  appointment: Yup.array().of(
    Yup.object().shape(
      {
        poNumber: Yup.string()
          .required("This field is required")
          .min(9, "Minimum 9 digits required")
          .max(10, "Maximum 10 digits required")
          .matches(alphaNumericPattern, "Only alphanumeric characters allowed"),
        gstIn: Yup.string()
          .required("This field is required")
          .trim()
          .min(15, "Minimum 15 digits required")
          .max(16, "Maximum 16 digits required")
          .matches(alphaNumericPattern, "Only alphanumeric characters allowed"),
        noOfCases: Yup.string()
          .required("This field is required")
          .matches(/^[0-9]+$/, "Must be only digits")
          .min(1, "Minimum 1 digit required"),
        countOfSkus: Yup.string()
          .required("This field is required")
          .matches(/^[0-9]+$/, "Must be only digits")
          .min(1, "Minimum 1 digit required"),
        appointmentDate: Yup.string().required(
          "Select appointment date , This field is required"
        ),
        materialTypeId: Yup.string().required(
          "Select one option , This field is required"
        ),
        vrn: Yup.string()
          .nullable()
          .notRequired()
          .when("vrn", {
            is: (value) => value?.length,
            then: (rule) =>
              rule
                .min(10, "Minimum 10 digit required (eg.MH01AB1234)")
                .max(10, "Maxmimum 10 digit required (eg.MH01AB1234)")
                .matches(
                  alphaNumericPattern,
                  "Only alphanumeric characters allowed"
                ),
          }),
        driverName: Yup.string()
          .nullable()
          .notRequired()
          .when("driverName", {
            is: (value) => value?.length,
            then: (rule) =>
              rule.matches(
                onlyCharactersWithSpacePattern,
                "Only characters allowed"
              ),
          }),
        driverContactNumber: Yup.string()
          .nullable()
          .notRequired()
          .when("driverContactNumber", {
            is: (value) => value?.length,
            then: (rule) =>
              rule
                .min(10, "Minimum 10 digit required")
                .max(10, "Maxmimum 10 digit required")
                .matches(/^[6-9]\d{9}$/, "Phone number is not valid"),
          }),
      },
      [
        ["driverContactNumber", "driverContactNumber"],
        ["vrn", "vrn"],
        ["driverName", "driverName"],
      ]
    )
  ),
});
